var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.detailmodel.schedule)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }